export default "__VITE_ASSET__D4fxc2Z0__"